import useDeleteLabourForecast from '@/api/mutations/labourForecast/useDeleteLabourForecast';
import { LabourForecast } from '@/api/queries/project/useGetLabourForecastForProject';
import { Button, Modal, ModalProps } from '@payaca/ambrosia';

import { FC } from 'react';

type Props = {
  labourForecast: LabourForecast;
  projectId: string;
} & Pick<ModalProps, 'isOpen' | 'onClose'>;
const DeleteLabourForecastModal: FC<Props> = (props) => {
  const { isOpen, onClose, labourForecast, projectId } = props;
  const { mutateAsync, isPending: isDeleting } =
    useDeleteLabourForecast(projectId);

  const handleDeleteLabourForecast = async () => {
    await mutateAsync(labourForecast.id).then(onClose);
  };

  return (
    <Modal title={`Delete labour forecast`} isOpen={isOpen} onClose={onClose}>
      <Modal.Body>
        <p className="mb-6 text-base">
          Are you sure you want to delete this labour forecast?
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Modal.Footer.Actions>
          <Button
            className="mr-2"
            variant="outline"
            disabled={isDeleting}
            onClick={onClose}
          >
            Keep
          </Button>
          <Button
            isProcessing={isDeleting}
            disabled={isDeleting}
            colour="red"
            onClick={handleDeleteLabourForecast}
          >
            Delete
          </Button>
        </Modal.Footer.Actions>
      </Modal.Footer>
    </Modal>
  );
};
export default DeleteLabourForecastModal;
